export default __webpack_public_path__ + "static/media/profile.93931e5a.png";